'use strict';

class Overlay {

    constructor() {
        
        const overlay = document.getElementById('overlay');
        const overlayActiveClass = 'overlay--active';
        const subMenus = document.querySelectorAll('.menu-item .dropdown-menu');
        const contactMenuToggler = document.querySelector('.primary-menu .contact-nav');
        const languageSwitch = document.querySelector('.primary-menu .language-switch');

        // add all items to listen to an array
        let toListen = [];
        subMenus.forEach(subMenu => {
            toListen.push(subMenu.parentNode);
        });

        if (contactMenuToggler) {
            toListen.push(contactMenuToggler);
        }
        
        if (languageSwitch) {
            toListen.push(languageSwitch);
        }

    
        if (overlay && toListen.length > 0) {

            toListen.forEach(item => {
                
                // on mouseover add active class
                item.addEventListener('mouseover', () => { overlay.classList.add(overlayActiveClass); })
                
                // on mouseout remove active class
                item.addEventListener('mouseout', () => { overlay.classList.remove(overlayActiveClass); })

            });

        }
    
    }

}

module.exports = Overlay;
